// Per-site eligibility copy + Eligibility List URL.
// SFRA reference: `org_hec/cartridge/client/default/react/helpers/facetUtils.js`.
//
// TODO: add FSASTORE + WDH entries once those site configs land in
// `~/config/sites.ts`. SFRA values:
//   FSASTORE: "All FSA Eligible",     "/fsa-eligibility-list"  (verify)
//   WDH:      "All FSA/HSA Eligible", URL TBD
export const SITE_ELIGIBILITY: Record<
  string,
  { text: string; listUrl: string }
> = {
  HSASTORE: { text: "All HSA Eligible", listUrl: "/hsa-eligibility-list" },
  FSASTORE: { text: "All FSA Eligible", listUrl: "/fsa-eligibility-list" },
};

// Caption shown below the cart's Continue-to-Checkout button.
// SFRA: `cart.product.eligibility.all` resource key, gated by the
// `showEligibility` site preference (FSA + HSA only).
export const SITE_CART_ELIGIBILITY_CAPTION: Record<string, string | null> = {
  HSASTORE: "All items are 100% HSA eligible.",
  FSASTORE: "All items are 100% FSA eligible.",
  WDH: null,
};
